import styled from "styled-components";

export const IconTitleTextTooltipIconBox = styled.img`
    height: 30px;
    width: 30px;
 `;
 